import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import DonutChart from "../../../../components/DonutChart";
import PreLoader from "../../../../components/PreLoader";
import { CasinoAPI } from "../../../../api/casino";
import { SportsBettingAPI } from "../../../../api/sportsBetting";
import { GamesAPI } from "../../../../api/games";
import { BonusesAPI } from "../../../../api/bonuses";
import { ExclusiveDealsAPI } from "../../../../api/exclusiveDeals";
import SectionWrapper from "../../../../components/SectionWrapper";

interface DataResponseType {
  active: number;
  inactive: number;
}
interface DataType {
  casinos: DataResponseType | undefined;
  sports: DataResponseType | undefined;
  games: DataResponseType | undefined;
  bonuses: DataResponseType | undefined;
  deals: DataResponseType | undefined;
}

const MainPage = () => {
  document.title = "Dashboard";
  const [data, setData] = useState<DataType>({
    casinos: undefined,
    sports: undefined,
    games: undefined,
    bonuses: undefined,
    deals: undefined,
  });

  async function fetchCasinoStats() {
    try {
      const res = await CasinoAPI.getCount();
      if (res) {
        setData((prevData) => ({ ...prevData, casinos: res }));
      }
    } catch (error) {
      alert("Something went wrong D! Try Again.");
    }
  }
  async function fetchSportsStats() {
    try {
      const res = await SportsBettingAPI.getCount();
      if (res) {
        setData((prevData) => ({ ...prevData, sports: res }));
      }
    } catch (error) {
      alert("Something went wrong D! Try Again.");
    }
  }
  async function fetchGamesStats() {
    try {
      const res = await GamesAPI.getCount();
      if (res) {
        setData((prevData) => ({ ...prevData, games: res }));
      }
    } catch (error) {
      alert("Something went wrong D! Try Again.");
    }
  }
  async function fetchBonusesStats() {
    try {
      const res = await BonusesAPI.getCount();
      if (res) {
        setData((prevData) => ({ ...prevData, bonuses: res }));
      }
    } catch (error) {
      alert("Something went wrong D! Try Again.");
    }
  }
  async function fetchDealsStats() {
    try {
      const res = await ExclusiveDealsAPI.getCount();
      if (res) {
        setData((prevData) => ({ ...prevData, deals: res }));
      }
    } catch (error) {
      alert("Something went wrong D! Try Again.");
    }
  }

  useEffect(() => {
    fetchCasinoStats();
    fetchSportsStats();
    fetchGamesStats();
    fetchBonusesStats();
    fetchDealsStats();
  }, []);

  if (
    !data?.casinos ||
    !data.sports ||
    !data.games ||
    !data.bonuses ||
    !data.deals
  )
    return <PreLoader />;
  return (
    <Container
      fluid
      className="p-0 m-0 flex flex-col bg-white text-black w-full h-screen relative px-4"
    >
      <SectionWrapper header="Casino24 Statistics">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 items-center w-full h-full lg:h-fit">
          <DonutChart
            active={data.deals.active}
            inactive={data.deals.inactive}
            title="Exclusive Deals"
          />
          <DonutChart
            active={data.casinos.active}
            inactive={data.casinos.inactive}
            title="Online Casinos"
          />
          <DonutChart
            active={data.sports.active}
            inactive={data.sports.inactive}
            title="Sports Betting"
          />
          <DonutChart
            active={data.games.active}
            inactive={data.games.inactive}
            title="Games"
          />
          <DonutChart
            active={data.bonuses.active}
            inactive={data.bonuses.inactive}
            title="Bonuses"
          />
        </div>
      </SectionWrapper>
    </Container>
  );
};

export default MainPage;
